import apiClient from '../apiClient';
import { GET_SALES_REPORT_URL } from '../apiUrl';

const getSalesReportApi = (startMonth, endMonth, year) => {
  return apiClient.get(GET_SALES_REPORT_URL(startMonth, endMonth, year));
};

export default getSalesReportApi;
